import requests from "./httpService";

const DayRentalBasicRateServices = {
  getAllDayRentalBasicRate: async (body) => {
    return requests.get(`/dayRentalBasicRate/`);
  },

  addDayRentalBasicRate: async (body) => {
    return requests.post(`/dayRentalBasicRate/add`, body);
  },
  getDayRentalBasicRateById: async (id) => {

    return requests.get(`/dayRentalBasicRate/${id}`);
  },

  updateDayRentalBasicRate: async (id, body) => {
    return requests.put(`/dayRentalBasicRate/update/${id}`, body);
  },

  deleteDayRentalBasicRate: async (id) => {
    return requests.delete(`/dayRentalBasicRate/delete/${id}`);
  },

   updateDayRentalStatus: async (id, body) => {
      return requests.post(`/dayRentalBasicRate/update-status/${id}`, body);
    }
};

export default DayRentalBasicRateServices;
